import { envVars } from '@core/environment/env-vars'

// Fallback for local dev/tests and until the SSM-backed env var is provisioned.
// Must match the canonical value that drives the OAuth consent — the leading
// `email profile` OpenID scopes are required for the backend to authenticate
// the connecting user; dropping them causes AUTHENTICATION_ERROR on activation.
export const GOOGLE_INTEGRATION_SCOPE_FALLBACK =
    'email profile https://www.googleapis.com/auth/admin.directory.user.readonly https://www.googleapis.com/auth/admin.reports.usage.readonly https://www.googleapis.com/auth/admin.directory.domain.readonly'

export const getGoogleIntegrationScope = (): string =>
    envVars.REACT_APP_GOOGLE_INTEGRATION_SCOPE ||
    GOOGLE_INTEGRATION_SCOPE_FALLBACK
